import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import baseUrl from '../utils/baseUrl';
import { ReactComponent as ArrowLeftIcon } from '../icons/arrow.left.svg';
import { ReactComponent as XmarkCircleIcon } from '../icons/xmark.circle.svg';
import saveData from '../utils/saveData';
import { loginWithCode } from '../data/repositories/LoginWithCode';
import { isNativeAndroid, sendToNative } from '../utils/NativeUtil';

const verificationCodePlaceholder = t('loginWithCodePage.verificationCodePlaceholder');

async function requestVerificationCode(email: string) {
  return fetch(`${baseUrl()}/auth/request_verification_code`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email: email
    })
  }).then((data) => data.json());
}

export default function LoginWithCodePage() {
  const { state } = useLocation();
  const [input, setInput] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => setInput(e.target.value);

  const onBackClick = () => {
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      return;
    }
  };

  const clearInput = () => {
    setInput('');
  };

  const postVerificationCode = async () => {
    const response = await loginWithCode(state.email, input);

    if (response?.success && response.jwt) {
      saveData('userId', response.userId);
      saveData('email', state.email);
      saveData('token', JSON.stringify(response.jwt));

      if (response.hasProfiles) {
        // SignIn 기준이 profile 생성 여부
        navigate('/home', {
          state: {
            redirectUrl: '/home'
          },
          replace: true
        });
        if (isNativeAndroid() && window.Android) {
          // TODO: Android 확인필요
        } else {
          sendToNative('{"type": "login"}');
        }
      } else {
        // Sign Up 로직
        navigate('/nickname-setting?init=true', { replace: true });
      }
    } else {
      alert(t('loginWithCodePage.verificationFailedAlert'));
    }
  };

  const reRequestVerificationCode = () => {
    requestVerificationCode(state.email).then((r) => {
      if (r.success) {
        alert(t('loginWithCodePage.successSendAlert'));
        // if(timerId) {
        //   clearInterval(timerId)
        // }
        // setCountDownSecond(300);
      } else {
        alert(t('loginWithCodePage.failedSendAlert'));
      }
    });
  };

  return (
    <div className="flex flex-col h-screen bg-background-light dark:bg-background-dark items-center w-[100vw] max-w-[570px] pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      <button
        className="mt-[14px] px-[16px] mb-[15px] w-full z-50 justify-start"
        onClick={onBackClick}
        type="button"
      >
        <ArrowLeftIcon className="fill-black dark:fill-white" />
      </button>
      <div className="flex flex-col items-center w-[100vw] max-w-[570px] px-[24px]">
        <div className="flex flex-col mt-[12px] w-full">
          <span className="text-left text-[24px] font-bold line-height-[120%]">
            {t('loginWithCodePage.title')}
          </span>
          <span className="text-main-light-4 dark:text-main-dark-4 mt-2 text-[15px]">
            {t('loginWithCodePage.description', { email: state.email })}
          </span>
        </div>
        <div className="relative mt-[52px] w-full">
          <input
            type="number"
            value={input}
            onChange={handleInputChange}
            placeholder={verificationCodePlaceholder}
            className="
              w-full
              bg-secondary-light dark:bg-secondary-dark
              hover:bg-secondary-light dark:hover:bg-secondary-dark
              rounded-[12px]
              py-[14px] px-[16px]
              text-gray-900 dark:text-gray-100
              placeholder-gray-400 dark:placeholder-gray-500
              focus:outline-none focus:ring-2 focus:ring-primary-light dark:focus:ring-primary-dark
              border
              border-transparent
            "
          />
          {input && (
            <button
              type="button"
              onClick={clearInput}
              className="
                  absolute right-[16px] top-1/2
                  -translate-y-1/2
                  w-[24px] h-[24px]
                  flex items-center justify-center
                "
            >
              <XmarkCircleIcon fill="gray" width={24} height={24} />
            </button>
          )}
        </div>
        <div className="mt-[20px]">
          <span className="text-onSecondary-light font-[13px] dark:text-onSecondary-dark">
            {t('loginWithCodePage.notReceivedMessage')}
            <button
              type="button"
              style={{ textDecoration: 'underline', paddingLeft: '3px' }}
              onClick={() => reRequestVerificationCode()}
            >
              {t('loginWithCodePage.sendAgainMessage')}
            </button>
          </span>
        </div>
        <div className="mt-auto w-full max-w-[570px] absolute bottom-[5%] px-[24px]">
          <button
            className={`
            text-white ${
              input !== ''
                ? 'bg-primary-light dark:bg-primary-dark text-white'
                : 'bg-disabled-light dark:bg-disabled-dark text-onDisabled-light dark:text-onDisabled-dark'
            }
            flex items-center justify-center
            w-full
            font-bold
            text-[16px]
            text-center
            rounded-[56px]
            disabled:opacity-50
            min-h-[52px]
          `}
            onClick={postVerificationCode}
            type="button"
          >
            {t('next')}
          </button>
        </div>
      </div>
    </div>
  );
}
